/** Format a number as a US dollar amount, e.g. 9.5 -> "$9.50". */
export const formatPrice = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '$0.00';
  return `$${amount.toFixed(2)}`;
};

/** Price shown for a template (single digital price, with legacy fallback). */
export const getTemplatePrice = (template) =>
  template?.price ?? template?.digital_price ?? 9.99;

/**
 * Order numbers ("O00012") as the customer sees them on the phone and in texts:
 * "Order O00012", or "Orders O00012, O00013" for a checkout of several invitations.
 * Returns '' when there are none (orders whose invitation was deleted).
 */
export const orderNumberLabel = (numbers) => {
  const list = (Array.isArray(numbers) ? numbers : [numbers]).filter(Boolean);
  if (list.length === 0) return '';
  return `${list.length > 1 ? 'Orders' : 'Order'} ${list.join(', ')}`;
};

/** Human friendly date, e.g. "Mar 4, 2026". Returns '' for invalid input. */
export const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
};

/** Copy text to the clipboard, falling back to a hidden textarea. */
export const copyToClipboard = async (text) => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) {
    // fall through to the legacy approach
  }
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch (e) {
    return false;
  }
};
